import { VIEW_BY } from '../../../../tool/dynamicReport/constant'
import ActivitiesRatiosAndRisk from './components/activitiesRatiosAndRisk'
import Commentary from './components/commentary'
import DistributionOfScore from './components/distributionOfScore'
import FinancialRatios from './components/financialRatios'
import PerformanceMatrix from './components/performanceMatrix'

const GeneralAnalysisExport = ({ isDynamicReport, settingDynamic = {} }) => {
  const { viewBy, check, radio } = settingDynamic

  return (
    <div>
      {viewBy === VIEW_BY.CHART ? (
        <>
          {check.includes('isPerformanceMatrix') ? (
            <PerformanceMatrix
              isDynamicReport={isDynamicReport}
              settingDynamic={settingDynamic}
            />
          ) : null}
          {check.includes('isDistributionOfScore') ? (
            <DistributionOfScore
              isDynamicReport={isDynamicReport}
              settingDynamic={settingDynamic}
            />
          ) : null}
        </>
      ) : (
        <>
          {radio === 'financialRatiosRadio' ? (
            <>
              <FinancialRatios
                isDynamicReport={isDynamicReport}
                settingDynamic={settingDynamic}
              />
              <ActivitiesRatiosAndRisk
                isDynamicReport={isDynamicReport}
                settingDynamic={settingDynamic}
              />
            </>
          ) : null}
          {radio === 'commentaryRadio' ? (
            <Commentary
              isDynamicReport={isDynamicReport}
              settingDynamic={settingDynamic}
            />
          ) : null}
        </>
      )}
    </div>
  )
}

export default GeneralAnalysisExport
